// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kurale&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: #f7f7f7;
}
.layout .left-layout {
  position: fixed;
  top: 0;
  left: 0;
  width: 17%;
}
.layout .right-layout {
  position: absolute;
  width: 82.8%;
  right: 0;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Layout.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AACF;AAAE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAEJ;AAAE;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;AAEJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Kurale&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap\");\n.layout {\n  position: relative;\n  height: 100vh;\n  width: 100vw;\n  background: #f7f7f7;\n  .left-layout {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 17%;\n  }\n  .right-layout {\n    position: absolute;\n    width: 82.8%;\n    right: 0;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
